import { DefaultStorageService } from './default-storage-service';
export const localStorageService = new DefaultStorageService(localStorage);
